<div class="home-container fade-in">
    <div class="hero-card">
        <div class="k-badge">K-Beauty Analysis</div>
        <h1>Discover Your<br><span class="highlight">Glass Skin</span> Potential</h1>
        <p>Unveil your true skin profile with our dermatologist-inspired quiz. Get personalized Korean skincare routines
            tailored just for you.</p>

        <div class="features">
            <div class="feature-item">
                <span class="icon">✨</span>
                <span>Skin Analysis</span>
            </div>
            <div class="feature-item">
                <span class="icon">🔬</span>
                <span>Smart Logic</span>
            </div>
            <div class="feature-item">
                <span class="icon">🌿</span>
                <span>K-Routine</span>
            </div>
        </div>

        <a routerLink="/quiz" class="btn-primary start-btn">
            Start Skin Test <span class="arrow">➜</span>
        </a>
    </div>
</div>